
import { Component, Vue } from 'vue-facing-decorator';

@Component({
    components: {}
})
export default class VerticalAd extends Vue {
  adsenseContent = '';
  mounted() {
    ((window as any).adsbygoogle = (window as any)?.adsbygoogle || []).push({});
  } 
}
